var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"space-around"}},_vm._l((_vm.parts),function(part,index){return _c('v-col',{key:index,attrs:{"cols":"10"}},[_c('za-calc-shipping-item',{attrs:{"part":part}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }